module.exports = __webpack_public_path__ + "images/donaupark-camping-logo.png";